import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useMatch, useResolvedPath } from "react-router-dom"
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { API_URL } from "../../config";


export default function MobileBanner() {
    const { id } = useParams();
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageSrc, setImageSrc] = useState('');

    useEffect(() => {
        const loadData = async () => {
            try {
                // Check cache first
                const cacheKey = 'kriterion-banner-films';
                const cacheTimeKey = 'kriterion-banner-films-time';
                const cachedData = localStorage.getItem(cacheKey);
                const cacheTime = localStorage.getItem(cacheTimeKey);

                if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < 300000) {
                    const parsed = JSON.parse(cachedData);
                    const randomFilm = getRandomItem(parsed);
                    preloadImage(randomFilm);
                    return;
                }

                // Safari-compatible axios configuration
                const axiosConfig = {
                    timeout: 10000, // 10 second timeout for Safari
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json'
                    },
                    withCredentials: false // Disable credentials for CORS
                };

                console.log('Starting banner API request (Safari debugging)...');

                const response = await axios.get(
                    `${API_URL}/api/films?populate=*&pagination[page]=1&pagination[pageSize]=100&filters[release][$lte]=${formatDate(new Date())}&sort=release:desc`,
                    axiosConfig
                );

                console.log('Banner API request completed:', response.data.data?.length + ' films loaded');

                const data = response.data.data;
                localStorage.setItem(cacheKey, JSON.stringify(data));
                localStorage.setItem(cacheTimeKey, Date.now().toString());

                const randomFilm = getRandomItem(data);
                preloadImage(randomFilm);
            } catch (error) {
                console.error('Axios banner request failed (Safari debugging):', {
                    message: error.message,
                    status: error.response?.status,
                    statusText: error.response?.statusText,
                    url: error.config?.url
                });

                // Safari fallback: try with native fetch
                console.log('Attempting banner fetch fallback for Safari...');
                try {
                    const fetchOptions = {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        mode: 'cors',
                        credentials: 'omit',
                        cache: 'no-cache'
                    };

                    const response = await fetch(
                        `${API_URL}/api/films?populate=*&pagination[page]=1&pagination[pageSize]=100&filters[release][$lte]=${formatDate(new Date())}&sort=release:desc`,
                        fetchOptions
                    );

                    if (!response.ok) {
                        throw new Error('Banner fetch request failed');
                    }

                    const responseData = await response.json();
                    console.log('Banner fetch fallback successful:', responseData.data?.length + ' films loaded');

                    const data = responseData.data;
                    localStorage.setItem('kriterion-banner-films', JSON.stringify(data));
                    localStorage.setItem('kriterion-banner-films-time', Date.now().toString());

                    const randomFilm = getRandomItem(data);
                    preloadImage(randomFilm);
                } catch (fetchError) {
                    console.error('Banner fetch fallback also failed:', fetchError);
                }
            }
        };

        loadData();
    }, []);

    const preloadImage = (film) => {
        if (!film?.attributes?.still?.data?.attributes?.formats) return;

        const formats = film.attributes.still.data.attributes.formats;
        const thumbnail = formats.thumbnail?.url;
        const medium = formats.medium?.url;

        if (thumbnail) {
            setImageSrc(thumbnail);
            const img = new Image();
            img.onload = () => {
                setImageLoaded(true);
                // Upgrade to medium image
                if (medium && medium !== thumbnail) {
                    const mediumImg = new Image();
                    mediumImg.onload = () => setImageSrc(medium);
                    mediumImg.src = medium;
                }
            };
            img.src = thumbnail;
        } else if (medium) {
            setImageSrc(medium);
            const img = new Image();
            img.onload = () => setImageLoaded(true);
            img.src = medium;
        }
    };

    const resolvedPath = useResolvedPath(id)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })

    return (
        <div 
            className='mobileBanner' 
            style={{
                backgroundImage: imageLoaded && imageSrc ? `url(${imageSrc})` : 'none',
                opacity: imageLoaded ? 1 : 0.8,
                transition: 'opacity 0.2s ease-in-out, background-image 0.2s ease-in-out'
            }}
        >
            <ul>
                {/* for selected, double border. add routing and active property */}
                <li className={isActive ? "double-border" : ""}><Link className='banner-link' to="/">Agenda</Link>
                </li>
                <li className={isActive ? "double-border" : ""}><Link className='banner-link' to="/filmprogrammas">Programmas</Link></li>
                <li className={isActive ? "double-border" : ""}><Link className='banner-link' to="/films">Alle films</Link></li>
            </ul>
        </div>
    );
}

function getRandomItem(list) {
    const randomItem = Math.floor(Math.random() * Math.floor(list.length));
    return list[randomItem]; // Pak random int van 0 naar lengte list (excl). 
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
